<script lang="ts">
	import type { CTAProps } from '@app/components/cms/types';
	import ButtonBoxPrimary from '$lib/elements/buttons/variants/ButtonBoxPrimary.svelte';
	import { storyblokEditable } from '@storyblok/svelte';
	import ButtonBoxSecondary from '$lib/elements/buttons/variants/ButtonBoxSecondary.svelte';
	import ButtonArrowPrimary from '$lib/elements/buttons/variants/ButtonArrowPrimary.svelte';
	import ButtonBoxWhite from '$lib/elements/buttons/variants/ButtonBoxWhite.svelte';
	import ButtonBox from '$lib/elements/buttons/variants/ButtonBox.svelte';

	export let props: CTAProps;
</script>

<div use:storyblokEditable={props}>
	{#if props.component === 'CTA-link-box'}
		<ButtonBoxPrimary
			props={{
				iconLeft: props.icon,
				label: props.label,
				hrefTarget: props.link.target,
				href: props.link.url || `/${props.link.cached_url}`
			}}
		/>
	{:else if props.component === 'CTA-link-box-secondary'}
		<ButtonBoxSecondary
			props={{
				iconLeft: props.icon,
				label: props.label,
				hrefTarget: props.link.target,
				href: props.link.url || `/${props.link.cached_url}`
			}}
		/>
	{:else if props.component === 'CTA-link-box-white'}
		<ButtonBoxWhite
			props={{
				iconLeft: props.icon,
				label: props.label,
				hrefTarget: props.link.target,
				href: props.link.url || `/${props.link.cached_url}`
			}}
		/>
	{:else if props.component === 'CTA-link-box-white-border'}
		<ButtonBoxWhite
			props={{
				iconLeft: props.icon,
				label: props.label,
				hrefTarget: props.link.target,
				href: props.link.url || `/${props.link.cached_url}`,
				withBorder: true
			}}
		/>
	{:else if props.component === 'CTA-link-arrow'}
		<ButtonArrowPrimary
			props={{
				label: props.label,
				hrefTarget: props.link.target,
				href: props.link.url || `/${props.link.cached_url}`
			}}
		/>
		{:else}
		<ButtonBox
			props={{
				label: props.label,
				hrefTarget: props.link.target,
				href: props.link.url || `/${props.link.cached_url}`,
				classNames: props.classNames
			}}
		/>
	{/if}
</div>
